import { Component, Input } from '@angular/core';
import { DashboardModel, DashboardModelDefaultValues } from '../dashboard-model';
import { DashboardService } from 'src/app/services/dashboard.service';
@Component({
    selector: 'app-dashboard-coach-branchadmin',
    templateUrl: './dashboard-coach-branchadmin.component.html',
    styleUrls: ['./dashboard-coach-branchadmin.component.scss'],
    standalone: false
})
export class DashboardCoachBranchadminComponent {
  @Input() dashboardModel: DashboardModel = DashboardModelDefaultValues();
  startDate: Date = new Date();
  endDate: Date = new Date();
  coachedParticipantCount = 0
  drpCoachParticipantValue: string = "1"
  constructor(private _dashboardService: DashboardService) { }

  ngOnInit() {
    this.getCoachedParticipantCount()
  }

  getCoachedParticipantCount() {
    this.startDate.setDate(this.startDate.getDate() - 30)
    // use tomorrow since we truncate time later and want to capture the entire day
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);    
    this.endDate = tomorrow;
    
    this._dashboardService.getCoachedParticipantCountForCoachAndAdmin(this.startDate, this.endDate).subscribe({
      next: (data) => {
        this.coachedParticipantCount = data;
      }
    })
  }

  ondropdownchange() {
    
    let startDate = new Date();
    switch (this.drpCoachParticipantValue) {
      case "1":
        startDate.setDate(startDate.getDate() - 30);
        break;
      case "2":        
        startDate.setDate(startDate.getDate() - 90);       
        break;
      case "3":       
        startDate.setDate(startDate.getDate() - 365);        
        break;
      default:
          break;
    }
    this.startDate = startDate;

    this.getCoachedParticipantCount();
  }
}
